export default "__VITE_ASSET__54ebc1e4__"